module.exports = __webpack_public_path__ + "img/PlusPrimary.c21d06ce.svg";